import React from 'react'
import _ from 'lodash'
import moment, { isMoment } from 'moment'
// isMoment
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withFormik } from 'formik'

import Field, {
  FieldLayout,
  FieldLabel,
  FieldBody,
  FieldItem,
} from '../../views/widgets/Field'
import CheckboxGroup from '../../views/widgets/CheckboxGroup'
import InputText from '../../views/widgets/InputText'
import config from '../../../config'
import InputDateTimePicker from '../../../modules/calendar/InputDateTimePicker'
import Media from '../../views/layouts/Media'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import { removePromotion } from '../../../actions/portal'
import InputTextarea from '../../views/widgets/InputTextarea'
import InputCheckbox from '../../views/widgets/InputCheckbox'
import { convertDateAndTimeToDateTime } from '../../../services/converter'
import withValidateBeforeSync from '../../../modules/common/withValidateBeforeSync'

const generateValidDayOfWeekCheckboxItem = index => {
  const validDayOfWeekList = [
    { title: 'อาทิตย์', seq: 0 },
    { title: 'จันทร์', seq: 1 },
    { title: 'อังคาร', seq: 2 },
    { title: 'พุธ', seq: 3 },
    { title: 'พฤหัสบดี', seq: 4 },
    { title: 'ศุกร์', seq: 5 },
    { title: 'เสาร์', seq: 6 },
  ]

  return _.map(validDayOfWeekList, ({ seq, title }) => (
    <InputCheckbox
      id={`index${index !== undefined ? index + 1 : 0}${seq}`}
      key={`${index}${seq}`}
      value={seq}
      name={title}
    />
  ))
}

const handleSpecificCaseAutoSync = (
  field,
  value,
  _handleAutoSync,
  _setFieldValue,
) => {
  _handleAutoSync(`validDate${field}`, value)
  _setFieldValue(`validDate${field}`, value)
  _handleAutoSync(`validTime${field}`, value)
  _setFieldValue(`validTime${field}`, value)
}

export const PromotionListItemForm = ({
  language = 'th',
  index,
  values,
  errors,
  setFieldValue,
  handleChange,
  handleBlur,
  handleAutoSync,
  handleAutoSyncOnChange,
  handleAutoSyncOnBlur,
  onRemovePromotion,
}) => (
  <Media onRemove={onRemovePromotion}>
    <div className="columns">
      <div className="column is-8">
        <Field label="ชื่อ">
          <InputText
            name={`title.${language}`}
            placeholder="Enter your title"
            onChange={handleChange}
            onBlur={handleAutoSyncOnBlur}
            value={values.title[language]}
            error={errors.title && errors.title[language]}
          />
        </Field>

        <Field label="รายละเอียด">
          <InputTextarea
            name={`description.${language}`}
            type="textarea"
            placeholder="Enter your description"
            onChange={handleChange}
            onBlur={handleAutoSyncOnBlur}
            value={values.description[language]}
          />
        </Field>

        <Field label="ลิงค์">
          <InputText
            name={`externalUrl`}
            placeholder="www.google.com"
            onChange={handleChange}
            onBlur={handleAutoSyncOnBlur}
            value={values.externalUrl}
            error={errors.externalUrl && errors.externalUrl[language]}
          />
        </Field>

        <Field label="ปรากฏเมื่อ">
          <InputDateTimePicker
            name="appearWhen"
            placeholder="Enter your appearWhen"
            onSave={value => {
              handleAutoSync('appearWhen', value)
            }}
            value={values.appearWhen}
          />
        </Field>

        <FieldLayout>
          <FieldLabel> เปิดใช้เมื่อ </FieldLabel>
          <FieldBody>
            <FieldItem>
              <InputDateTimePicker
                name="validDateTimeFrom"
                placeholder="Enter your ValidDateFrom"
                onSave={value =>
                  handleSpecificCaseAutoSync(
                    'From',
                    value,
                    handleAutoSync,
                    setFieldValue,
                  )
                }
                value={values.validDateTimeFrom}
              />
            </FieldItem>
            <FieldItem>
              <InputDateTimePicker
                name="validDateTimeTo"
                placeholder="Enter your validDateTo"
                onSave={value =>
                  handleSpecificCaseAutoSync(
                    'To',
                    value,
                    handleAutoSync,
                    setFieldValue,
                  )
                }
                value={values.validDateTimeTo}
              />
            </FieldItem>
          </FieldBody>
        </FieldLayout>
      </div>
      <div className="column is-4">
        <Field label="เปิดใช้ในวัน">
          <CheckboxGroup
            name="validDayOfWeek"
            values={values.validDayOfWeek}
            onChange={values => {
              let name = 'validDayOfWeek'
              let value = _.map(values, value => parseInt(value, 0))
              setFieldValue(name, value)
              handleAutoSync(name, value)
            }}
          >
            {generateValidDayOfWeekCheckboxItem(index)}
          </CheckboxGroup>
        </Field>
      </div>
    </div>
  </Media>
)

const initialValidDateTime = (date, time) => {
  if (isMoment(date) && isMoment(time)) {
    return convertDateAndTimeToDateTime(date, time)
  } else {
    return moment()
  }
}

const initialPromotion = ({
  appearWhen,
  validDayOfWeek,
  validDateFrom,
  validDateTo,
  validTimeFrom,
  validTimeTo,
  ...promotion
}) => ({
  title: config.getLangText(),
  description: config.getLangText(),
  externalUrl: '',
  ...promotion,
  validDateTimeFrom: initialValidDateTime(validDateFrom, validTimeFrom),
  validDateTimeTo: initialValidDateTime(validDateTo, validTimeTo),
  validDayOfWeek:
    validDayOfWeek === undefined ? [0, 1, 2, 3, 4, 5, 6] : validDayOfWeek,
  appearWhen: appearWhen ? appearWhen : moment(),
})

const validatePromotion = (values, { language }) => {
  const errors = {}
  if (!values.title || !values.title[language]) {
    errors.title = { th: 'Required' }
  }
  if(values.externalUrl && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm.test(values.externalUrl)){
    errors.externalUrl = { th: 'รูปแบบ url ไม่ถูกต้อง' }
  }
  return errors
}

export const withPromotionListItemForm = withFormik({
  mapPropsToValues: ({ promotion = {} }) => {
    return initialPromotion(promotion)
  },
  validate: validatePromotion,
  enableReinitialize: true,
  displayName: 'Promotion', // helps with React DevTools
})

export default compose(
  connect(
    ({ info: { language } }) => ({ language }),
    (dispatch, { index }) => ({
      onRemovePromotion: () => dispatch(removePromotion(index)),
    }),
  ),
  withPromotionListItemForm,
  withPortalAutoRemoteSync(props => ({ path: `promotions.${props.index}` })),
  withValidateBeforeSync({
    validate: validatePromotion,
  }),
)(PromotionListItemForm)



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/PromotionListItemForm.js